let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("p91SI")).then(() => parcelRequire('6cT2s'));